import { c as _c } from "react/compiler-runtime";
import * as React from "react";
interface CloseIconProps {
  fill?: string;
}
function CloseIcon(t0) {
  const $ = _c(2);
  const {
    fill
  } = t0;
  const t1 = fill ?? "#D9D9D9";
  let t2;
  if ($[0] !== t1) {
    t2 = <svg data-testid="close-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill={t1} /></svg>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export default React.memo(CloseIcon);